import axios from 'axios'
const BASE_API = process.env.REACT_APP_BASE_API || 'http://localhost:3000'

export const customFetch = async (endpoint, options) => {
  const url = BASE_API + endpoint

  const defaultHeader = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }

  const controller = new AbortController()
  options.signal = controller.signal

  options.method = options.method || 'GET'
  options.headers = options.headers
    ? { ...defaultHeader, ...options.headers }
    : defaultHeader

  options.body = JSON.stringify(options.body) || false
  if (!options.body) delete options.body

  setTimeout(() => controller.abort(), 9000)

  try {
    const res = await fetch(url, options)
    return res.json()
  } catch (err) {
    return err
  }
}

export const customFetchFormData = async(endpoint, data) =>{
  const url = BASE_API + endpoint

  const defaultHeader = {
    'Content-Type': 'multipart/form-data'
  }

  try {
    const res = await axios({
      url,
      headers:defaultHeader,
      method:'POST',
      data
    })
    return res.data
  } catch (err) {
    return err
  }
}
